<div [class.disabled]="disabled" *ngIf="item" class="product">
  <div class="left">
    <div
      [appBackgroundImage]="item.product.photos[0] | productImage | async"
      [class.no-image]="item.product.photos.length < 1"
      class="img border-sm"
    ></div>
  </div>
  <div class="right">
    <div class="top">
      <div class="product-name">{{ item.product.name }}</div>
      <div class="close-btn" (click)="itemRemoveClick.next()">
        <app-svg-icon [name]="'close'"></app-svg-icon>
      </div>
    </div>
    <hr />
    <div class="bottom">
      <app-price-label
        [value]="item.product | getRelevantProductPrice | appCurrency | async"
        [secondaryCurrencyAlight]="'start'"
      ></app-price-label>
      <app-quantity-selector
        [value]="item.quantity"
        [min]="1"
        [max]="99"
        [isCompact]="true"
        (valueIncreased)="increasedAmount.emit()"
        (valueDecreased)="decreasedAmount.emit()"
        [disabled]="disabled"
      ></app-quantity-selector>
    </div>
  </div>
</div>
